export {
  AX_COLOR_PRESETS,
  AX_COLOR_PRIMARY_FALLBACK,
  AX_TIER_DEFAULT_COLOR_PRESET,
  getColorPresetPrimary,
  isColorPresetKey,
} from './color-presets';
export type {
  AxColorPresetKey,
  AxTierDefaultColorPresetKey,
  ColorPresetDef,
} from './color-presets';
export { defaultBranding } from './default';
export { applyBranding } from './apply-branding';
export { resolveBrandingConfig } from './env';
export { mergeBrandingConfig } from './merge-config';
export type { BrandingOverride, BrandingOverridePatch } from './merge-config';
export type { BrandingConfig, BrandingColors, BrandingFeatures, BrandingLogo } from './types';
export type { BrandingEnv } from './env';

/** Vue provide/inject 키 (string 키 충돌 방지를 위해 Symbol 사용 가능하나, 외부 주입 호환을 위해 string 채택) */
export const BRANDING_INJECTION_KEY = 'branding' as const;
